import Vue from 'vue'
import App from './App.vue'
import store from './store'
import '@/assets/css/main.css'
import VueRouter from 'vue-router'
import Login from './components/views/Login.vue'
import GithubAuth from './components/views/GithubAuth.vue'
import ProjectListing from './components/views/ProjectListing.vue'
import AddProject from './components/views/AddProject.vue'
import Welcome from './components/views/Welcome.vue'
import CreateSubscription from './components/views/CreateSubscription.vue'

require('typeface-montserrat')
require('typeface-baloo')

Vue.use(VueRouter)

Vue.config.productionTip = false

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/welcome',
      name: 'Welcome',
      component: Welcome
    },
    {
      path: '/authenticated/github',
      name: 'GithubAuth',
      component: GithubAuth
    },
    {
      path: '/',
      name: 'ProjectListing',
      component: ProjectListing
    },
    {
      path: '/add-project',
      name: 'AddProject',
      component: AddProject
    },
    {
      path: '/create-subscription',
      name: 'CreateSubscription',
      component: CreateSubscription
    }
  ]
})

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
